import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../models/Redeem';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import * as Globals from '../globals';
@Component({
  selector: 'app-ritel-online',
  templateUrl: './ritel-online.component.html',
  styleUrls: ['./ritel-online.component.css']
})
export class RitelOnlineComponent implements OnInit {
  authMenu: any;
  tab: number=1;
  userProfile: any;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/ritelonline/monitoring/pemesanan/0') {
          this.tab = 1;
          this.router.navigate(['/ritelonline/monitoring/pemesanan/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/ritelonline/monitoring/pemesanan/1']);
    }
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.authMenu = Globals.getAuthMenu(202, this.userProfile);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/ritel-online/ritel-online.component.ts